export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-03.3986829b.png";